import { FC } from 'react';

import {
  useProcessedBannerStore,
  useProcessedWorkStore,
} from '../../../studentApp/hooks';
import { MOBILE_MARGIN } from '../../constants';

import { StyledBanner } from './banner';
import { HamburgerMenu } from './hamburger';
import { Hand } from './hand';
import { WorkNameAndProgress } from './workNameAndProgress';

export const MobileBanner: FC = () => {
  const { themeColor, themeColor2 } = useProcessedBannerStore();
  const { isTesting } = useProcessedWorkStore();
  const { isShowHand } = useProcessedBannerStore();

  return (
    <StyledBanner
      color={themeColor}
      color2={themeColor2}
      style={{
        justifyContent: 'space-between',
        paddingLeft: MOBILE_MARGIN,
        paddingRight: MOBILE_MARGIN,
      }}
    >
      <WorkNameAndProgress />

      {!isTesting && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          {isShowHand && <Hand />}
          <HamburgerMenu />
        </div>
      )}
    </StyledBanner>
  );
};
